import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import organizerRepository from 'modules/organizer/domain/repositories/organizer-repository';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';

interface useFetchAvailableFeatureProps {
  userTournamentId?: number;
  isEnabled?: boolean;
}

export function useFetchAvailableFeature(props?: useFetchAvailableFeatureProps) {
  const { userTournamentId: extraUserTournamentId, isEnabled = true } = props ?? {};

  const userTournamentId = useSelector(authStoreUserTournamentId) || extraUserTournamentId;

  return useQuery({
    queryKey: ['available-feature', userTournamentId],
    queryFn: () => {
      if (!userTournamentId) return Promise.resolve(null);
      return organizerRepository.fetchAvailableFeature(userTournamentId);
    },
    enabled: !!userTournamentId && isEnabled,
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
